import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { House, Compass, User, Plus } from "@phosphor-icons/react";

const items = [
  { to: "/feed", icon: House, label: "Home", testid: "nav-home" },
  { to: "/discover", icon: Compass, label: "Discover", testid: "nav-discover" },
  { to: "/create", icon: Plus, label: "Create", center: true, testid: "nav-create" },
  { to: "/me", icon: User, label: "Profile", testid: "nav-profile" },
];

export default function BottomNav() {
  const location = useLocation();
  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 pointer-events-none" data-testid="bottom-nav">
      <div className="max-w-md mx-auto px-4 pb-4">
        <div className="pointer-events-auto glass floating-nav-shadow rounded-2xl px-4 py-3 flex items-center justify-between">
          {items.map((it) => {
            const Icon = it.icon;
            const active = location.pathname === it.to;
            if (it.center) {
              return (
                <NavLink key={it.to} to={it.to} data-testid={it.testid}
                  className="-translate-y-5 h-14 w-14 rounded-2xl bg-primary text-primary-foreground flex items-center justify-center glow glow-hover tap-press">
                  <Icon size={26} weight="bold" />
                </NavLink>
              );
            }
            return (
              <NavLink key={it.to} to={it.to} data-testid={it.testid}
                className={`flex flex-col items-center gap-1 px-3 py-1 ${active ? "text-primary" : "text-muted-foreground"} tap-press`}>
                <Icon size={22} weight={active ? "fill" : "regular"} />
                <span className="text-[10px] font-mono uppercase tracking-widest">{it.label}</span>
              </NavLink>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
